import type BoltMetaArgs from 'types/BoltMetaArgs';

import type { Region } from './region';
import { regions } from './region';

export function getAlternateTagsForAllRegions(args: BoltMetaArgs) {
  const path = args.location.pathname;
  const region = args.matches[0].data.region;

  const gbDefaultsAlternates = getGbDefaults(region, path);

  const regionalAlternates = regions
    .filter((r) => r.code !== 'GB')
    .map((r) => getRegionalAlternate(region, r, path));

  return [...regionalAlternates, ...gbDefaultsAlternates];
}

export function getAlternateTagsForRegions(
  args: BoltMetaArgs,
  regionCodes: string[] = []
) {
  const path = args.location.pathname;
  const region = args.matches[0].data.region;

  const gbDefaultsAlternates = getGbDefaults(region, path);

  console.log(regionCodes);

  const regionalAlternates = regions
    .filter((r) => r.code !== 'GB' && regionCodes.includes(r.code))
    .map((r) => getRegionalAlternate(region, r, path));

  console.log(regionalAlternates);

  return [...regionalAlternates, ...gbDefaultsAlternates];
}

function getRegionalAlternate(
  current: Region,
  alternate: Region,
  path: string
) {
  const href = `${current.baseUrl.replace(current.tld, alternate.tld)}${path}`;

  return {
    href,
    hreflang: `${alternate.code}-${alternate.lang}`.toLowerCase(),
    rel: 'alternate',
    tagName: 'link'
  };
}

function getGbDefaults(region: Region, path: string) {
  const href = `${region.baseUrl}${path}`.replace(region.tld, '.co.uk');

  return [
    {
      href,
      hreflang: 'en-gb',
      rel: 'alternate',
      tagName: 'link'
    },
    {
      href,
      hreflang: 'x-default',
      rel: 'alternate',
      tagName: 'link'
    }
  ];
}
